import { Card, Skeleton, Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { LimitApprovalSkeleton } from './LimitApprovalSkeleton';
import styles from './PlatformConsentAcceptanceSkeleton.module.scss';

export const PlatformConsentAcceptanceSkeleton = () => {
  const isMobile = useIsMobile();
  return (
    <Space
      direction={isMobile ? 'vertical' : undefined}
      size={32}
    >
      <Space
        size={16}
        direction="vertical"
        className={styles.leftPanel}
      >
        <LimitApprovalSkeleton />

        <Card>
          <Space
            size={16}
            direction="vertical"
          >
            {[1, 2, 3, 4].map((i) => {
              return (
                <Space
                  align="center"
                  size={16}
                  key={i}
                >
                  <Skeleton.Avatar className={styles.avatar} />
                  <Skeleton.Paragraph />
                </Space>
              );
            })}
          </Space>
        </Card>
      </Space>

      <Space
        size={16}
        direction="vertical"
      >
        <Skeleton.Paragraph
          inverted
          width={60}
        />

        {[1, 2, 3, 4, 5].map((item) => {
          return (
            <Card key={item}>
              <Space size={16}>
                <Skeleton.Avatar />
                <Space
                  direction="vertical"
                  size={8}
                >
                  <Skeleton.Paragraph />
                  <Skeleton.Paragraph />
                </Space>

                <Skeleton.Button />
              </Space>
            </Card>
          );
        })}
      </Space>
    </Space>
  );
};
